import { render, staticRenderFns } from "./NPCBehaviourEffect.vue?vue&type=template&id=7289b882&scoped=true&"
import script from "./NPCBehaviourEffect.vue?vue&type=script&lang=js&"
export * from "./NPCBehaviourEffect.vue?vue&type=script&lang=js&"
import style0 from "./NPCBehaviourEffect.vue?vue&type=style&index=0&id=7289b882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7289b882",
  null
  
)

export default component.exports